import { FunctionField, FunctionFieldProps, useRecordContext } from 'react-admin';
import { format, parse } from 'date-fns'

interface DateFieldProps extends Omit<FunctionFieldProps, 'children' | 'render'> {
  showTime?: boolean,
  format?: string,
}

const renderFunc = (source: string, theFormat: string, showTime?: boolean) => (record: any) => {
  // console.log(record[source]);
  if ('' === record[source] || undefined === record[source] || null === record[source] || '0000-00-00 00:00:00' === record[source] || '0000-00-00' === record[source]) {
    return '--';
  } else {
    let parseFormat = (19 === record[source].length) ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd';
    let date = parse(record[source], parseFormat, new Date());
    return format(date, theFormat);
  }
}

const DateField = ({ showTime, ...props }: DateFieldProps) => {
  const { source } = props;
  const record = useRecordContext();
  // console.log(record[source]);
  if (undefined === record || undefined === source || undefined === props.format) {
    return <></>;
  }

  return (
    <FunctionField  {...props} render={renderFunc(source, props.format, showTime)}></FunctionField >
  )
}

DateField.defaultProps = {
  format: 'yyyy-MM-dd',
}

export default DateField;
